import { Link, useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Route } from "../../../Routers/RouteList";
import { Href } from "../../../Constants/Constants";

const Breadcrumbs = () => {
  const Path = useLocation();
  const SymbolRegex = /[!@#$%&*()_+{}[\]:;"'<>,.?/\\|`~\-=]/g;
  const [firstPart, secondPart] = Path.pathname.split("/").slice(1).map((item) => item.replace(SymbolRegex, " "));
    
  return (
    <section className="breadcrumb-main">
      <div className="custom-container">
        <h2>{firstPart === "blog" ? firstPart : secondPart}</h2>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to={Route.Messenger}>{"Home"}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to={Href}>{firstPart === "blog" ? firstPart : secondPart}</Link>
          </BreadcrumbItem>
        </Breadcrumb>
      </div>
    </section>
  );
};

export default Breadcrumbs;
